import { IRootState } from '../../../store'
import { ICommentsState } from '../store/comments.types'

export const getComments = (state: IRootState): ICommentsState => state.__comments
